import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { DirectionProvider } from './context/direction-provider'
import { FontProvider } from './context/font-provider'
import { I18nProvider } from './context/i18n-provider'
import { ThemeProvider } from './context/theme-provider'
import './lib/i18n'
import { createQueryClient } from './lib/query-client'
// Generated Routes
import { routeTree } from './routeTree.gen'
// Styles
import './styles/index.css'

// Create query client with router getter
// Router will be created after queryClient, so we use a getter function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let routerInstance: any = null
const queryClient = createQueryClient(() => {
  if (!routerInstance) {
    throw new Error('Router not initialized')
  }
  return routerInstance
})

// Create router instance
const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
})
routerInstance = router

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

import { reloadOnServiceWorkerUpdate } from '@/lib/sw-reload'

// Pick up a new deploy without the operator clearing caches by hand.
reloadOnServiceWorkerUpdate()

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
          <ThemeProvider>
            <FontProvider>
              <DirectionProvider>
                <RouterProvider router={router} />
              </DirectionProvider>
            </FontProvider>
          </ThemeProvider>
        </I18nProvider>
      </QueryClientProvider>
    </StrictMode>
  )
}
